import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';


export default class TextInput extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    type: PropTypes.string
  };

  render() {
    let {type = 'text', value, onChange} = this.props;
    let props = assign({}, this.props);
    delete props.type;
    delete props.value;
    delete props.onChange;

    return (
      <input
          {...props}
          type={type}
          value={value || ''}
          onChange={event => onChange(event.target.value || null)} />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/TextInput.js